/**
 * Class is used to hold all the screen labels
 */
export class ScreenLabels {
    // Constants for cancel button
    static CANCEL_BUTTON = 'CANCEL';
    // Constants for empty string ''
    static EMPTY_STRING = '';
    // Constants for OK
    static OK = 'OK';
    // Constants for SAVE
    static SAVE = 'SAVE';
    // Constants for YES
    static YES = 'YES';
    // Constants for NO
    static NO = 'NO';
    // Constants for NA
    static NA = 'NA';
    // constant for Allocated
    static ALLOCATED = 'Allocated';
    // constant for In Transit
    static IN_TRANSIT = 'In Transit';
    // constant for Ground
    static GROUND  = 'Ground';
    // constant for A
    static A = 'A';
    // constant for F
    static F = 'F';
    // constant for G
    static G = 'G';
    // Constant for D
    static D = 'D';
    // constant for DIO
    static DIO = 'DIO';
    // constant for logout warning
    static TIMEOUT_WARNING = 'TIMEOUT WARNING';
    // constant for Reset
    static RESET = 'RESET';
    // constant for Cancel Reserve
    static CANCEL_RESERVE = 'CANCEL RESERVE';
    // Constant for Close
    static CLOSE = 'CLOSE';
    static CALCULATE ='CALCULATE';
    // Constant for CLEAR;
    static CLEAR = 'CLEAR';
    // constant for Available Colors
    static AVAILABLE_COLORS = 'Available Colors';
    // constant for Delete
    static DELETE = 'DELETE';
    // Constant for Confirm button
    static CONFIRM = 'Confirm'
    // Constant for Apply for Credit button
    static APPLY_FOR_CREDIT = 'Apply for Credit'
}
